export default __webpack_public_path__ + "static/media/bookmark-add.639e8d47.svg";